
export default {
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    gutterX: {
      type: Boolean,
      default: true
    },
    image: {
      type: Object,
      default: null
    },
    direction: {
      type: String,
      default: 'row'
    }
  },
  vessel: {
    title: {
      fontSize: { all: '3xl', md: '4xl' },
      marginBottom: 'sm'
    },
    subtitle: {
      $extend: 'title',
      fontSize: { all: 'xl', lg: '2xl' }
    }
  },
  data() {
    return {
      showHeader: false
    }
  },
  computed: {
    leftEnter() {
      return this.direction == 'row' ? 'left' : 'right'
    },
    rightEnter() {
      return this.direction == 'row' ? 'right' : 'left'
    },
    gutterY() {
      return this.$screen.md ? 'medium' : 'small'
    }
  },
  mounted() {
    this.showHeader = true
  }
}
